import * as actions from './karmaReward.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { KarmaRewardModel } from '@smarttask-common/src/lib/models/Karma/KarmaRewardModel';

export const karmaRewardAdapter = createEntityAdapter<KarmaRewardModel>({
    selectId: (x) => x.reward_id,
});
export interface karmaRewardState extends EntityState<KarmaRewardModel> {}

export const initialState: karmaRewardState = karmaRewardAdapter.getInitialState({});

export function karmaRewardReducers(state: karmaRewardState = initialState, action: actions.karmaRewardActions) {
    switch (action.type) {
        case actions.karmaRewardActionTypes.ADD_REWARD:
            return karmaRewardAdapter.addOne(action.reward, state);

        case actions.karmaRewardActionTypes.ADD_REWARDS:
            return karmaRewardAdapter.addMany(action.rewards, state);

        case actions.karmaRewardActionTypes.UPSERT_REWARD:
            return karmaRewardAdapter.upsertOne(action.reward, state);

        case actions.karmaRewardActionTypes.UPSERT_REWARDS:
            return karmaRewardAdapter.upsertMany(action.rewards, state);

        case actions.karmaRewardActionTypes.UPDATE_REWARD:
            return karmaRewardAdapter.updateOne(action.reward, state);

        case actions.karmaRewardActionTypes.UPDATE_REWARDS:
            return karmaRewardAdapter.updateMany(action.rewards, state);

        case actions.karmaRewardActionTypes.DELETE_REWARD:
            // if(state.selectedGTaskId == action.id){
            //   state.selectedGTaskId = undefined;
            // }
            return karmaRewardAdapter.removeOne(action.id, state);

        case actions.karmaRewardActionTypes.DELETE_REWARDS:
            // if(action.ids.indexOf(state.selectedGTaskId) > -1){
            //   state.selectedGTaskId = undefined;
            // }
            return karmaRewardAdapter.removeMany(action.ids, state);

        case actions.karmaRewardActionTypes.DELETE_ALL_REWARDS:
            return karmaRewardAdapter.removeMany(action.ids, state);

        case actions.karmaRewardActionTypes.DELETE_ALL:
            return karmaRewardAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getkarmaRewardState = createFeatureSelector<karmaRewardState>('karmaReward');

export const { selectIds, selectEntities, selectAll, selectTotal } = karmaRewardAdapter.getSelectors(getkarmaRewardState);
